import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=ffc102d4&functional=true&lang=pug"
var script = {}
import style0 from "./Box.vue?vue&type=style&index=0&id=ffc102d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports